<template>
<div class="chapter">
<div class="inner_page">
<div class="pagebreak">
</div>
<p style="text-align:center; margin-top:1pc"></p>
<h1 class="tocchaptitle"><a id="contents"></a>The Millionth Circle</h1>
<p style="text-align:center; margin-top:1pc"></p>
<p class="center"><a href="#/06chapter01#c1">1 . Zen and the Art of Circle Maintenance</a></p>
<p class="center"><a href="#/07chapter02#c2">2 . How to Change the World: The Millionth Circle</a></p>
<p class="center"><a href="#/08chapter03#c3">3 . Casting the Circle: Who, What, Where, When?</a></p>
<p class="center"><a href="#/09chapter04#c4">4 . Centering the Circle</a></p>
<p class="center"><a href="#/10chapter05#c5">5 . A Circle of Equals</a></p>
<p class="center"><a href="#/11chapter06#c6">6 . A Circle Needs to Be Safe</a></p>
<p class="center"><a href="#/12chapter07#c7">7 . A Circle in Trouble</a></p>
<p class="center"><a href="#/13chapter08#c8">8 . Ceremonial Circle</a></p>
<p class="center"><a href="#/14chapter09#c9">9 . The Millionth Circle</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05-contents.vue?434b0190